export default __webpack_public_path__ + "images/text_color.2aba1e8.svg";